/* eslint-disable unused-imports/no-unused-vars */
import axios from '@axios'

/**
 * @param {{ context: import('vuex/types/index')['ActionContext'], stateName: string }} actionTrigger
 * @param {('get'|'post'|'put'|'delete')} method The HTTP method to use with axios
 * @param {string} endpoint The endpoint to call
 * @param {any} [data] The data to send to the endpoint
 * @returns {Promise<import('axios').AxiosResponse>} The response from the endpoint
 */
async function autoResolve(actionTrigger, method, endpoint, data) {
    const response = await axios[method](endpoint, data)
    if (actionTrigger.stateName) {
        actionTrigger.context.commit(actionTrigger.stateName, response.data)
    }
    return response
}
/// @deprecated
export default {
    namespaced: true,
    state: {
        lineasNegocio: [],
        macroDepartamentos: [],
        departamentos: [],
        establecimientos: [],
        centrosCostoAll: [],
        subCentrosCostoAll: [],
        usuarios: [],
        permisosUnidadNegocio: [],
        permisosEstablecimiento: [],
        permisosMacroDepart: [],
        permisosMacroDepartXusuario: [],
        autorizacionesCC: [],
        lineaNegocioXusuario: [],
        establecimientosXusuario: [],
        macroDepartamentosXusuario: [],
        aprobacionesCC: [],
        centrosCostoXestab: [],
        aprobacionesSC: [],
        permisosCCSC: [],
        permisosCCSCxUsuario: [],
        paises: [],
        ciudades: [],
        estabXlineaNegocio: [],
        macroDepXunidadNegocio: [],
        departamentosXusuario: [],
        metodosPago: [],
    },
    getters: {
        getUnidadesNegocio: state => state.lineasNegocio,
        getMacroDepartamentos: state => state.macroDepartamentos,
        getMacroDepXunidadNegocio: state => state.macroDepXunidadNegocio,
        getDepartamentos: state => state.departamentos,
        getEstablecimientos: state => state.establecimientos,
        getCentrosCostoAll: state => state.centrosCostoAll,
        getSubCentrosCostoAll: state => state.subCentrosCostoAll,
        getUsuarios: state => state.usuarios,
        getPermisosUnidadNegocio: state => state.permisosUnidadNegocio,
        getPermisosEstablecimiento: state => state.permisosEstablecimiento,
        getPermisosMacroDepart: state => state.permisosMacroDepart,
        getPermisosMacroDepartXusuario: state => state.permisosMacroDepartXusuario,
        getAutorizacionesCC: state => state.autorizacionesCC,
        getUnidadesNegocioXusuario: state => state.lineaNegocioXusuario,
        getEstablecimientosXusuario: state => state.establecimientosXusuario,
        getMacroDepartamentosXusuario: state => state.macroDepartamentosXusuario,
        getDepartamentosXusuario: state => state.departamentosXusuario,
        getAprobacionesCC: state => state.aprobacionesCC,
        getCentrosCostoXestab: state => state.centrosCostoXestab,
        getAprobacionesSC: state => state.aprobacionesSC,
        getPermisosCCSC: state => state.permisosCCSC,
        getPermisosCCSCxUsuario: state => state.permisosCCSCxUsuario,
        getPaises: state => state.paises,
        getCiudades: state => state.ciudades,
        getEstabXunidadNegocio: state => state.estabXlineaNegocio,
        getMetodosPago: state => state.metodosPago,
    },
    mutations: {
        SET_LINEAS_NEGOCIO(state, lineasNegocio) {
            state.lineasNegocio = lineasNegocio
        },
        SET_MACRODEPARTAMENTOS(state, macroDepartamentos) {
            state.macroDepartamentos = macroDepartamentos
        },
        SET_MACRODEP_X_UNIDAD_NEGOCIO(state, macroDepXunidadNegocio) {
            state.macroDepXunidadNegocio = macroDepXunidadNegocio
        },
        SET_DEPARTAMENTOS(state, departamentos) {
            state.departamentos = departamentos
        },
        SET_ESTABLECIMIENTOS(state, establecimientos) {
            state.establecimientos = establecimientos
        },
        SET_CENTROS_COSTO_ALL(state, centrosCostoAll) {
            state.centrosCostoAll = centrosCostoAll
        },
        SET_SUBCENTROS_COSTO_ALL(state, subCentrosCostoAll) {
            state.subCentrosCostoAll = subCentrosCostoAll
        },
        SET_USUARIOS(state, usuarios) {
            state.usuarios = usuarios
        },
        SET_PERMISO_LINEA_NEGOCIO(state, permisosUnidadNegocio) {
            state.permisosUnidadNegocio = permisosUnidadNegocio
        },
        SET_PERMISO_ESTABLECIMIENTO(state, permisosEstablecimiento) {
            state.permisosEstablecimiento = permisosEstablecimiento
        },
        SET_PERMISO_MACRO_DEPART(state, permisosMacroDepart) {
            let json = JSON.stringify(permisosMacroDepart)
            json = json.replaceAll(',"children":[]', '').replaceAll('"children":[]', '')
            json = JSON.parse(json)
            state.permisosMacroDepart = json
            // state.permisosMacroDepart = permisosMacroDepart
        },
        SET_PERMISO_MACRO_DEPART_X_USUARIO(state, permisosMacroDepartXusuario) {
            state.permisosMacroDepartXusuario = permisosMacroDepartXusuario
        },
        SET_AUTORIZACIONES_CC(state, autorizacionesCC) {
            state.autorizacionesCC = autorizacionesCC
        },
        SET_LINEA_NEGOCIO_X_USUARIO(state, lineaNegocioXusuario) {
            state.lineaNegocioXusuario = lineaNegocioXusuario
        },
        SET_ESTABLECIMIENTOS_X_USUARIO(state, establecimientosXusuario) {
            state.establecimientosXusuario = establecimientosXusuario
        },
        SET_MACRODEPARTAMENTOS_X_USUARIO(state, macroDepartamentosXusuario) {
            state.macroDepartamentosXusuario = macroDepartamentosXusuario
        },
        SET_DEPARTAMENTOS_X_USUARIO(state, departamentosXusuario) {
            state.departamentosXusuario = departamentosXusuario
        },
        SET_APROBACIONES_CC(state, aprobacionesCC) {
            state.aprobacionesCC = aprobacionesCC
        },
        SET_CENTROS_COSTO_X_ESTAB(state, centrosCostoXestab) {
            state.centrosCostoXestab = centrosCostoXestab
        },
        SET_APROBACIONES_SC(state, aprobacionesSC) {
            state.aprobacionesSC = aprobacionesSC
        },
        SET_PERMISOS_CCSC(state, permisosCCSC) {
            let json = JSON.stringify(permisosCCSC)
            json = json.replaceAll(',"children":[]', '').replaceAll('"children":[]', '')
            json = JSON.parse(json)
            state.permisosCCSC = json
        },
        SET_PERMISOS_CCSC_X_USUARIO(state, permisosCCSCxUsuario) {
            state.permisosCCSCxUsuario = permisosCCSCxUsuario
        },
        SET_PAISES(state, paises) {
            state.paises = paises
        },
        SET_CIUDADES(state, ciudades) {
            state.ciudades = ciudades
        },
        SET_ESTAB_X_LINEA_NEGOCIO(state, estabXlineaNegocio) {
            state.estabXlineaNegocio = estabXlineaNegocio
        },
        SET_EMPLEADOS(state, empleados) {
            state.empleados = empleados
        },
        SET_METODOS_PAGO(state, metodosPago) {
            state.metodosPago = metodosPago
        },
    },
    actions: {
        fetchMetodosPago({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/metodos-pago')
                    .then(response => {
                        commit('SET_METODOS_PAGO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUnidadesNegocio({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/unidadesNegocio')
                    .then(response => {
                        commit('SET_LINEAS_NEGOCIO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarUnidadNegocio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/agregarUnidadNegocio', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarUnidadNegocio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/editarUnidadNegocio', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEliminarUnidadNegocio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/eliminarUnidadNegocio', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMacroDepartamentos({ commit }, filter) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/macro-departamentos', { params: filter })
                    .then(response => {
                        commit('SET_MACRODEPARTAMENTOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMacroDepXunidadNegocio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/macroDepXunidadNegocio', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_MACRODEP_X_UNIDAD_NEGOCIO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarMacroDepartamento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/agregarMacroDepartamento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarMacroDepartamento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/editarMacroDepartamento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEliminarMacroDepartamento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/eliminarMacroDepartamento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDepartamentos({ commit }, filter) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/departamentos', { params: filter })
                    .then(response => {
                        commit('SET_DEPARTAMENTOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        async fetchDepartamentosXMacro({ commit }, { id_macro_dpto, filter }) {
            return await axios.get('/api/auth/administracion/departamentos')
        },
        postAgregarDepartamento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/agregarDepartamento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarDepartamento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/editarDepartamento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEliminarDepartamento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/eliminarDepartamento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEstabXunidadNegocio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/estabXunidadNegocio', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_ESTAB_X_LINEA_NEGOCIO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEstablecimientos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/establecimientos', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_ESTABLECIMIENTOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarEstablecimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/agregarEstablecimiento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarEstablecimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/editarEstablecimiento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEliminarEstablecimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/eliminarEstablecimiento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCentrosCostoAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/centrosCostoAll')
                    .then(response => {
                        commit('SET_CENTROS_COSTO_ALL', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarCentroCosto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/agregarCentroCosto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarCentroCosto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/editarCentroCosto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEliminarCentroCosto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/eliminarCentroCosto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSubCentrosCostoAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/subcentrosCostoAll')
                    .then(response => {
                        commit('SET_SUBCENTROS_COSTO_ALL', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarSubCentroCosto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/agregarSubCentroCosto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarSubCentroCosto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/editarSubCentroCosto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEliminarSubCentroCosto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/eliminarSubCentroCosto', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUsuarios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/usuarios', { params: data })
                    .then(response => {
                        commit('SET_USUARIOS', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPermisosUnidadNegocio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/permisosUnidadNegocio', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_PERMISO_LINEA_NEGOCIO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarPermisoUnidadNegocio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/agregarPermisoUnidadNegocio', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosEstablecimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/permisosEstablecimiento', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_PERMISO_ESTABLECIMIENTO', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* fetchPermisosEstabXusuario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/permisos-establecimiento-x-usuario', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_PERMISO_ESTABLECIMIENTO', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }, */

        postAgregarPermisoEstablecimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/agregarPermisoEstablecimiento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosMacroDepart({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/permisosMacroDepart', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_PERMISO_MACRO_DEPART', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosMacroDepartXusuario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/permisosMacroDepartXusuario', { params: data })
                    .then(response => {
                        const data = response.data.map(e => {
                            return Object.values(e)
                        })
                        commit('SET_PERMISO_MACRO_DEPART_X_USUARIO', data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarPermisoMacroDepart({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/agregarPermisoMacroDepart', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarAutorizacionCC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/agregarAutorizacionCC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAutorizacionesCC({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/autorizacionesCC')
                    .then(response => {
                        commit('SET_AUTORIZACIONES_CC', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEliminarAutorizacionCC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/eliminarAutorizacionCC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUnidadesNegocioXusuario({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/unidadesNegocioXusuario')
                    .then(response => {
                        commit('SET_LINEA_NEGOCIO_X_USUARIO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDepartamentosXusuario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/establecimientosXusuario', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_ESTABLECIMIENTOS_X_USUARIO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchMacroDepartamentosXusuario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/macroDepartamentosXusuario', { params: data })
                    .then(response => {
                        commit('SET_MACRODEPARTAMENTOS_X_USUARIO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAprobacionesCC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/aprobacionesCC', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_APROBACIONES_CC', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAprobarCC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/aprobarCC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAprobarModificacionCC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/aprobarModificacionCC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAprobarAnulacionCC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/aprobarAnulacionCC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postNoAprobarCC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/noAprobarCC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postNoAprobarModificacionCC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/noAprobarModificacionCC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postNoAprobarAnulacionCC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/noAprobarAnulacionCC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCentrosCostoXestab({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/centrosCostoXestab', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_CENTROS_COSTO_X_ESTAB', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAprobacionesSC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/aprobacionesSC', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_APROBACIONES_SC', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAprobarSC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/aprobarSC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAprobarModificacionSC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/aprobarModificacionSC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAprobarAnulacionSC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/aprobarAnulacionSC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postNoAprobarSC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/noAprobarSC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postNoAprobarModificacionSC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/noAprobarModificacionSC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postNoAprobarAnulacionSC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/noAprobarAnulacionSC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPaises({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/paises')
                    .then(response => {
                        commit('SET_PAISES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCiudades({ commit }, id_pais) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/administracion/ciudades/${id_pais}`)
                    .then(response => {
                        commit('SET_CIUDADES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosCCSC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/permisosCCSC', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_PERMISOS_CCSC', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarPermisosCCSC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/agregarPermisosCCSC', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosCCSCxUsuario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/permisosCCSCxUsuario', {
                        params: data,
                    })
                    .then(response => {
                        const data = response.data.map(e => {
                            return Object.values(e)
                        })
                        commit('SET_PERMISOS_CCSC_X_USUARIO', data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEmpleados({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/empleados', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_EMPLEADOS', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        async fetchPresupuestos(_, filter) {
            return await axios.get('/api/auth/administracion/presupuestos', { params: filter })
        },
        async fetchPresupuestoXMacroDpto(_, { id_macro_departamento, filter }) {
            return await axios.get(
                `/api/auth/administracion/macro-departamentos/${id_macro_departamento}/presupuesto`,
                filter
            )
        },
        async fetchDepartamentosPermitidos({ commit }, filter) {
            const response = await axios.get('/api/auth/administracion/departamentos/permitidos', { params: filter })

            commit('SET_DEPARTAMENTOS', response.data)
            return response
        },

        fetchPermisosUnidadNegocioEstab({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/permisos-establecimiento/permisos-unidad-negocio-establecimientos', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_PERMISO_LINEA_NEGOCIO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postPermisoUnidadNegocio(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/permisos-establecimiento/unidad-negocio', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postPermisoEstablecimiento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/permisos-establecimiento/establecimiento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosMacroDepXunidadNegocio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/permisos-macrodpto/permisos-macro-departamento', {
                        params: data,
                    })
                    .then(response => {
                        commit('SET_MACRODEP_X_UNIDAD_NEGOCIO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postPermisoDepartamento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/permisos-macrodpto/departamento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postPermisoMacroDpto(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/permisos-macrodpto/macrodepartamento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
